// packages/web-ui/src/panels/file-viewer/FileViewer.tsx
//
// Story W3-S2 AC #1.1 — eager wrapper consumed by `<TabContent>`'s
// files-destination dispatch. Defers the heavy CodeMirror 6 body via
// `React.lazy`. MUST stay free of `codemirror|@codemirror/*` imports — the
// `no-eager-codemirror` ESLint guard enforces this at lint time.
//
// AC #12.1 — empty-path placeholder ("Select a file from the tree…").

import { lazy, Suspense } from 'react';
import type { JSX } from 'react';
import { FileViewerSkeleton } from './FileViewerSkeleton.js';

const FileEditor = lazy(() => import('./FileEditor.js'));

export interface FileViewerProps {
  /** Workspace-relative path; empty string → empty-state placeholder. */
  path: string | null;
  /** Forwarded to CM6 EditorState.readOnly extension. */
  readOnly?: boolean;
}

export function FileViewer(props: FileViewerProps): JSX.Element {
  const path = props.path ?? '';
  if (path.length === 0) {
    return (
      <div
        data-testid="file-viewer-shell"
        data-state="empty"
        className="flex h-full w-full items-center justify-center"
        style={{ backgroundColor: 'var(--color-cream-50)' }}
      >
        <div
          className="rounded-none border p-6 text-sm"
          style={{
            width: 240,
            height: 160,
            backgroundColor: 'var(--color-cream-100)',
            borderColor: 'var(--color-taupe-300)',
            color: 'var(--color-taupe-700)',
          }}
        >
          Select a file from the tree, or drag one here.
        </div>
      </div>
    );
  }
  return (
    <Suspense fallback={<FileViewerSkeleton />}>
      <FileEditor path={path} readOnly={props.readOnly} />
    </Suspense>
  );
}

export default FileViewer;
